<template lang="pug">
div
  button.change-button(
    :disabled="disabled || loading"
    @click="confirm"
    data-testid="action-btn-prioridad-asignacion"
  )
    b-spinner(v-if="loading" small)
    span(v-else) Prioridad de asignación
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionPrioridadAsignacion',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  methods: {
    ...mapActions('OTStore', ['marcarPrioridadAsignacion', 'getOT']),
    async confirm() {
      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          'La OT se asignará antes que las demás y seguirá siendo prioritaria hasta que se cierre. ¿Continuar?',
          {
            title: 'Por favor Confirma',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'SÍ',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        if (!confirmed) return
        await this.executeWithLoading(async () => {
          await this.marcarPrioridadAsignacion({ otId: this.ot.ot })
          this.$bvToast.toast('OT marcada con prioridad de asignación.', {
            variant: 'success',
          })
          await this.getOT(this.ot.ot)
          this.$emit('changed')
        })
      } catch (error) {
        console.error('Error al marcar prioridad de asignación:', error)
        this.$bvToast.toast('Error al marcar prioridad de asignación.', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
